import { render, staticRenderFns } from "./InformationTable.vue?vue&type=template&id=156f8494"
import script from "./InformationTable.vue?vue&type=script&lang=js"
export * from "./InformationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports